import { Channel, Episode, LaunchType, Playable, Season, Show } from '../../types/launch';

export interface LaunchState {
  backdrop: string;
  channel: Channel;
  collection: Show[];
  episode: Episode;
  iconic: string;
  launchChannelId: string;
  launchShowId: string;
  liveAsset?: Playable;
  redirect: string;
  season: Season;
  seasonEpisodes: Episode[];
  show: Show;
  title: string;
  topShow: Show;
  type: LaunchType;
  newUserFastPlayable?: boolean;
}

export default {
  type: '',
  show: {},
  episode: {},
  season: {},
  channel: {},
  topShow: {},
  collection: [],
  seasonEpisodes: [],
  launchShowId: '',
  launchChannelId: '',
  iconic: '',
  title: '',
  redirect: '',
};
